import type { TemplateResult } from 'lit';
import { repeat } from 'lit/directives/repeat.js';

export function renderEdgelessWidgets(widgets: Record<string, TemplateResult>) {
  return repeat(
    Object.entries(widgets),
    ([id]) => id,
    ([_, widget]) => widget
  );
}
